module.exports = __webpack_public_path__ + "static/media/icon_eye.678ee790.svg";